export const theme = {
  light: {
    colors: {
      green: '#04F5D4',
      lightBlue: '#02D8E7',
      blue: '#00BBF9',
      mediumGreen: '#7FD09D',
      lightGreen: '#BFDA6F',
      yellow: '#FEE440',
      orange: '#F89F7B',
      pink: '#F15AB5',
      lightPurple: '#C65BCD',
      brightPurple: '#f8c0ff',
      purple: '#9160CB',
      darkPurple: '#8149c3',
      dark: '#40454A',
      medium: '#919EAB',
      inputBorder: '#d9d9d9',
      line: '#DFE3E7',
      light: '#F4F6F8',
      white: '#FFFFFF',
      red: '#FA3838',
    },
  },
}

// contrast color (black or white) for text on a colored background
function rgbToYIQ({ r, g, b }) {
  return (r * 299 + g * 587 + b * 114) / 1000
}
function hexToRgb(hex) {
  if (!hex || hex === undefined || hex === '') {
    return undefined
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined
}

export function contrast(colorHex, threshold = 128) {
  if (colorHex === undefined) {
    return theme.light.colors.dark
  }

  const rgb = hexToRgb(colorHex)

  if (rgb === undefined) {
    return theme.light.colors.dark
  }

  return rgbToYIQ(rgb) >= threshold
    ? theme.light.colors.dark
    : theme.light.colors.white
}
